import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';

import '@/assets/styles/index.scss' // global css
import vueI18n from 'vue-i18n'
Vue.use(vueI18n)
const locale=localStorage.getItem('lang')
const i18n=new vueI18n({
	locale:locale||'zh',
	messages:{
		'zh':require('@/assets/lang/zh'),
		'en':require('@/assets/lang/en'),
		'korean':require('@/assets/lang/korean'),
	}
})
Vue.config.productionTip = false
Vue.use(Element)

new Vue({
  router,
  i18n,//添加这一行
  render: h => h(App),
}).$mount('#app')
